import {qspost} from '@/plugins/axios'

/*
 * 专家—列表
 * @constructor jack
 * */
export const UserList = (searchName, page, limit) => qspost('/admin/User/UserList', {searchName, page, limit})

/*
 * 专家—新增
 * @constructor jack
 * */
export const userSave = (name, phone, remark, id) => qspost('/admin/User/userSave', {name, phone, remark, id})

/*
 * 专家—详情
 * @constructor jack
 * */
export const userDetail = (id) => qspost('/admin/User/userDetail', {id})

/*
 * 专家—删除
 * @constructor jack
 * */
export const userDel = (id) => qspost('/admin/User/userDel', {id})

/*
 * 专家—修改状态
 * @constructor jack
 * */
export const setUserStatus = (id, status) => qspost('/admin/User/setStatus', {id, status})


/*
 * 社会组织—列表
 * @constructor jack
 * */
export const orgList = (searchName, page, limit) => qspost('/admin/Organization/orgList', {searchName, page, limit})

/*
 * 社会组织—新增
 * @constructor jack
 * */
export const orgSave = (title, credit_code, name, phone, id) => qspost('/admin/Organization/orgSave', {
  title,
  credit_code,
  name,
  phone,
  id
})

/*
 * 社会组织—详情
 * @constructor jack
 * */
export const orgDetail = (id) => qspost('/admin/Organization/orgDetail', {id})

/*
 * 社会组织—删除
 * @constructor jack
 * */
export const orgDel = (id) => qspost('/admin/Organization/orgDel', {id})

/*
 * 社会组织—修改状态
 * @constructor jack
 * */
export const setOrgStatus = (id, status) => qspost('/admin/Organization/setStatus', {id, status})


/*
 * 评估打分表-列表
 * @constructor jack
 * */
export const playList = (searchName, page, limit) => qspost('/admin/Playing/playList', {searchName, page, limit})

/*
 * 评估打分表-新增
 * @constructor jack
 * */
export const playSave = (year, name, content, id) => qspost('/admin/Playing/playSave', {year, name, content, id})

/*
 * 评估打分表-删除
 * @constructor jack
 * */
export const playDel = (id) => qspost('/admin/Playing/playDel', {id})

/*
 * 评估打分表-复制
 * @constructor jack
 * */
export const copyScoreForm = (id) => qspost('/admin/Playing/copyScoreForm', {id})


/*
 * 评估打分表-锁定/开放
 * @constructor jack
 * */
export const setPlayStatus = (id, status) => qspost('/admin/Playing/setStatus', {id, status})

/*
 * 评估打分表-详情
 * @constructor jack
 * */
export const playDetail = (id) => qspost('/admin/Playing/orgDetail', {id})


/*
 * 评估打分表-获取各级别指标列表
 * @constructor jack
 * */
export const indicatorsList = (playing_id,level,id) => qspost('/admin/Playing/indicatorsList', {playing_id,level,id})

/*
 * 评估打分表-添加各级别指标 - 添加/编辑
 * @constructor jack
 * */
export const indicatorsSave = (playing_id,level,p_id,name,id) => qspost('/admin/Playing/indicatorsSave', {playing_id,level,p_id,name,id})

/*
 * 评估打分表-添加各级别指标 - 添加/编辑
 * @constructor jack
 * */
export const saveAffiliatedContent = (playing_id,id,content,total_points,json,is_focus) => qspost('/admin/Playing/saveAffiliatedContent', {playing_id,id,content,total_points,json,is_focus})



/*
 * 评估打分表-各级别指标 - 删除
 * @constructor jack
 * */
export const indicatorsDel = (level,id) => qspost('/admin/Playing/indicatorsDel', {level,id})

/*
 * 评估打分表-各级别指标 - 排序
 * @constructor jack
 * */
export const setSort = (playing_id,level,ids) => qspost('/admin/Playing/setSort', {playing_id,level,ids})

/*
 * 评估打分表-4级别指标 - 详情
 * @constructor jack
 * */
export const getAffiliatedContent = (id) => qspost('/admin/Playing/getAffiliatedContent', {id})

/* 参评专家管理*/
/*
 * 评估打分表-已添加的参评专家列表
 * @constructor jack
 * */
export const getEstimateExpertList = (id,searchName,page,limit) => qspost('/admin/user_info/UserList', {id,searchName,page,limit})

/*
 * 评估打分表-可添加的参评的专家列表
 * @constructor jack
 * */
export const getExpertList = (id) => qspost('/admin/user_info/getUserList', {id})

/*
 * 评估打分表-将专家添加至打分表
 * @constructor jack
 * */
export const expertToScore = (playing_id,user_id) => qspost('/admin/user_info/setOrg', {playing_id,user_id})


/*
 * 评估打分表-参评专家-删除
 * @constructor jack
 * */
export const delEstimateExpert = (id) => qspost('/admin/user_info/orgDel', {id})

/*
 * 评估打分表-获取参评专家下的参评机构
 * @constructor jack
 * */
export const getExpertOrgList = (playing_id,user_id) => qspost('/admin/user_info/orgEnumList', {playing_id,user_id})

/*
 * 评估打分表-保存参评专家下的参评机构
 * @constructor jack
 * */
export const saveExpertOrgList = (id,org_id) => qspost('/admin/user_info/setOrg', {id,org_id})




/* 参评机构管理*/
/*
 * 评估打分表-获取可参评的社会组织机构
 * @constructor jack
 * */
export const getEstimateOrgList = (id) => qspost('/admin/org_info/orgEnumList', {id})

/*
 * 评估打分表-当前评估打分表下-参评的社会组织机构
 * @constructor jack
 * */
export const getScoreOrgList = (id,searchName,page,limit) => qspost('/admin/org_info/orgList', {id,searchName,page,limit})


/*
 * 评估打分表-将社会组织添加至打分表
 * @constructor jack
 * */
export const orgToScore = (playing_id,organization_id) => qspost('/admin/org_info/orgSave', {playing_id,organization_id})

/*
 * 评估打分表- 删除 将社会组织
 * @constructor jack
 * */
export const delEstimateOrg = (id) => qspost('/admin/org_info/orgDel', {id})

/*
 * 评估打分表- 社会组织评估记录
 * @constructor jack
 * */
export const EstimateOrgManagement = (id) => qspost('/admin/org_info/orgManagement', {id})

/*
 * 评估打分表- 社会组织评估记录
 * @constructor jack
 * */
export const orgDelManagement = (id) => qspost('/admin/org_info/orgDelManagement', {id})

/*
 * 评估打分表- 社会组织评估记录预览
 * @constructor jack
 * */
export const getOrgDetail = (id) => qspost('/admin/org_info/orgDetail', {id})


/*
 * 评估打分表- 设置机构评估等级
 * @constructor jack
 * */
export const saveTotalLevel = (org_id,playing_id,total_level) => qspost('/admin/org_info/saveTotalLevel', {org_id,playing_id,total_level})

/*
 * 评估打分表- 详情页—修改四级分数
 * @constructor jack
 * */
export const saveEditScore = (id,score,remark) => qspost('/admin/org_info/saveF', {id,score,remark})


